import React, { useState, useEffect } from 'react';

interface Props { name: string, desc: string, onTap: any }
export const Button: React.FC<Props> = ({ name, desc, onTap }) =>
{
    const [img, setImg] = useState(`/assets/ui_${name}.png`);

    const onEnter = () =>
    {
        setImg(`/assets/ui_${name}_hover.png`);
    }
    const onLeave = () =>
    {
        setImg(`/assets/ui_${name}.png`);
    }
    const onDown = () =>
    {
        setImg(`/assets/ui_${name}_down.png`);
    }

    return (
        <div className={`button ${name}`}>
            <img src={img} onClick={onTap} onMouseEnter={onEnter} onMouseLeave={onLeave} onMouseDown={onDown} />
            <div className="desc">{desc}</div>
        </div>
    );
};